<template lang="pug">
section.loot_boxes
  .loot_boxes__title(v-html="$t('promo.loot_boxes.title')")
  .loot_boxes__wrap
    .box(v-for="i in chestsArray.length" :key="i" :class="`box--${i}`")
      .box__img
      .box__price(v-html="getChestPrice(i - 1)")
      a.box__consist(target="_blank" :href="getChestLink(i)" v-html="$t('promo.loot_boxes.consist')")
      button.button(
        :class="{ 'button--disabled': getChestPrice(i - 1) > balance }"
        :disabled="getChestPrice(i - 1) > balance"
        @click="exchangeBox(i - 1)"
        v-html="$t('promo.button.exchange')"
      )
  .loot_boxes__desc.loot_boxes__text(v-html="$t('promo.loot_boxes.desc')")
  .loot_boxes__terms.loot_boxes__text(v-html="$t('promo.loot_boxes.terms')")

  Popup(v-if="currentlyShownModal === 'exchange'" @close="closeModal")
    template(#head)
      div(v-html="$t('promo.loot_boxes.popup.exchange.title')")
    template(#body)
      .popup__desc(v-html="$t('promo.loot_boxes.popup.exchange.desc')")
      .popup__content
        .box(:class="`box--${currentBoxNumber + 1}`")
          .box__img
    template(#buttons)
      button.button(@click="buyBox" v-html="$t('promo.button.approve')")
      button.button(@click="closeModal" v-html="$t('promo.button.cancel')")

  Popup(v-if="currentlyShownModal === 'success' && offerImage && offerName" @close="closeModal")
    template(#head)
      div(v-html="$t('promo.loot_boxes.popup.success.title')")
    template(#body)
      .popup__desc(v-html="`${$t('promo.loot_boxes.popup.success.desc')} ${offerName}`")
      .popup__content
        img.popup__prize(:src="offerImage")
      .popup__desc(v-html="$t('promo.loot_boxes.popup.success.added_to_inventory')")
    template(#buttons)
      button.button(@click="closeModal" v-html="$t('promo.button.close')")
</template>

<script>
import Popup from "./Popup";

export default {
  name: "LootBoxes",
  components: {
    Popup,
  },
  props: {
    chestOffers: {
      type: Object,
      default: () => {},
    },
    activityKey: {
      type: String,
      default: null,
    },
    balance: {
      type: Number,
      default: null,
    },
    chestLinks: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      offerImage: null,
      offerName: null,
      currentlyShownModal: null,
      currentBoxNumber: null,
    };
  },
  computed: {
    chestsArray() {
      return Object.keys(this.chestOffers);
    },
  },
  methods: {
    getChestLink(index) {
      return this.chestLinks[`link${index}`];
    },
    getChestPrice(index) {
      return this.chestOffers[this.chestsArray[index]];
    },
    exchangeBox(number) {
      this.currentBoxNumber = number;
      this.showModal("exchange");
    },
    buyBox() {
      this.$api.questsWithRatingService
        .openChest(this.activityKey, this.chestsArray[this.currentBoxNumber])
        .run()
        .then(response => {
          if (this.$api.isApiResponseError(response)) {
            throw this.$api.getApiResponseError(response);
          } else {
            this.$emit("decreaseBalance", this.getChestPrice(this.currentBoxNumber));
            const offerName = response.data.result[0];
            this.getOfferImage(offerName);
            this.closeModal();
          }
        });
    },
    getOfferImage(offerName) {
      this.$api.storeService
        .getOffersExtended({ names: [offerName] })
        .run()
        .then(response => {
          if (this.$api.isApiResponseError(response)) {
            throw this.$api.getApiResponseError(response);
          } else {
            this.offerImage = response.data.result.data[0].images.preview;
            this.offerName = response.data.result.data[0].title.ru;
            this.showModal("success");
          }
        });
    },
    showModal(name) {
      this.currentlyShownModal = name;
    },
    closeModal() {
      this.currentlyShownModal = null;
      this.currentBoxNumber = null;
      this.offerImage = null;
    },
  },
};
</script>
